module.exports = __webpack_public_path__ + "assets/img/3.f2e59e80.jpg";